import {
    CircularProgress,
    Container,
    makeStyles,
    Paper
} from '@material-ui/core'
import React from 'react'
import { TomImageItem } from '../../tom/components/tom-image-item'
import { Button, Loading } from '../../root/components/common'
import { useSelector } from 'react-redux'
import { OptionSwitcher } from '../../root/components/common/option-switcher/option-switcher'
const TOM_LANDING_PAGE = 'https://www.traplinked.com/tom/'

const useStyles = makeStyles(theme => ({
    content: {
        maxWidth: '100%',
        height: '100%',
        position: 'relative'
    },
    paper: {
        marginBottom: 16
    },
    root: {
        width: '100%',
        display: 'flex',
        justifyContent: 'center'
    },
    btn: {
        marginBottom: 16,
        marginTop: 16
    },
    loaderWrapper: {
        width: '100%',
        height: 300,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    emptyState: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        height: 300
    },
    isFetchingIndicator: {
        position: 'absolute',
        left: '50%'
    }
}))

export const PicturesList = ({
    data,
    fetchNextPage,
    hasNextPage,
    isLoading,
    isFetching,
    isFetchingNextPage,
    queryKey,
    filters,
    setFilters
}) => {
    const cls = useStyles()
    const { locale, hasTomDevices } = useSelector(state => state.main)

    return (
        <div className={cls.content}>
            {isFetching && !isLoading && (
                <CircularProgress
                    className={cls.isFetchingIndicator}
                    color="inherit"
                    size={24}
                />
            )}
            {hasTomDevices && (
                <div
                    style={{
                        marginBottom: 15,
                        display: 'flex',
                        justifyContent: 'end'
                    }}>
                    <OptionSwitcher
                        options={{
                            relevant: locale.tom.relevantPictures,
                            all: locale.tom.allPictures
                        }}
                        selected={
                            filters.is_evaluation_required === '1'
                                ? 'relevant'
                                : 'all'
                        }
                        onChange={value => {
                            const newFilters = { ...filters }
                            if (filters.is_evaluation_required === '1') {
                                delete newFilters.is_evaluation_required
                            } else {
                                newFilters.is_evaluation_required = '1'
                            }
                            setFilters(newFilters)
                        }}
                    />
                </div>
            )}
            {isLoading && hasTomDevices && <Loading width="500" />}
            {!isLoading && hasTomDevices && (
                <div
                    style={{ height: '100%', overflow: 'auto', width: '100%' }}>
                    <Container maxWidth="md">
                        {data?.pages?.[0]?.data?.length ? (
                            <>
                                {data.pages.map(page => (
                                    <React.Fragment key={page?.nextSkip}>
                                        {page.data.map(i => (
                                            <Paper
                                                key={i.id}
                                                className={cls.paper}
                                                elevation={2}>
                                                <TomImageItem
                                                    queryKey={queryKey}
                                                    item={i}
                                                    notProcessedStatuses={[
                                                        'not_processed',
                                                        'ai_processed'
                                                    ]}
                                                />
                                            </Paper>
                                        ))}
                                    </React.Fragment>
                                ))}
                                {hasNextPage && (
                                    <Button
                                        onClick={fetchNextPage}
                                        disabled={isFetchingNextPage}
                                        className={cls.btn}
                                        fullWidth>
                                        {isFetchingNextPage ? (
                                            <CircularProgress
                                                color="inherit"
                                                size={24}
                                            />
                                        ) : (
                                            locale.tom.loadMore
                                        )}
                                    </Button>
                                )}
                            </>
                        ) : (
                            <div className={cls.emptyState}>
                                <div>{locale.tom.noPictures}</div>
                            </div>
                        )}
                    </Container>
                </div>
            )}
            {!isLoading && !hasTomDevices && (
                <Container maxWidth="md">
                    <div className={cls.emptyState}>
                        <div>{locale.tom.notUsingTom}</div>
                        <Button
                            onClick={() =>
                                window.open(TOM_LANDING_PAGE, '_blank')
                            }
                            style={{ marginTop: 16 }}>
                            {locale.tom.discoverTom}
                        </Button>
                    </div>
                </Container>
            )}
        </div>
    )
}
